import { toValidDate } from "@spiriidk/utils";

import { typedFetchNoImpersonate, zodValidator } from "~/api/typed-fetch";
import {
  EnvironmentBuildResponseSchema,
  EnvironmentBuildSearchSchema,
} from "~/features/debug-info/schemas";

interface EnvironmentInfo {
  env: string;
  serverBuild: string;
  serverBuildDate: Date | null;
  clientBuild: string;
  clientBuildDate: Date | null;
}

function parseDate(value: unknown): Date | null {
  if (typeof value !== "string") return null;

  return toValidDate(value) ?? null;
}

async function getEnvironmentInfo(
  signal?: AbortSignal
): Promise<EnvironmentInfo> {
  const response = await typedFetchNoImpersonate("/enums/", {
    validateResponse: zodValidator(EnvironmentBuildResponseSchema),
    validateSearch: zodValidator(EnvironmentBuildSearchSchema, {
      build: "1",
      env: "1",
    }),
    signal,
  });
  const { env, build, buildTime } = response;
  const appVersion: unknown = import.meta.env.VITE_APP_VERSION;
  const buildDate: unknown = import.meta.env.VITE_BUILD_DATE;
  const clientBuild = typeof appVersion === "string" ? appVersion : "Unknown";
  const clientBuildDate = parseDate(buildDate);
  const serverBuildDate = parseDate(buildTime);

  return {
    env,
    serverBuild: build,
    serverBuildDate,
    clientBuild,
    clientBuildDate,
  };
}

export { getEnvironmentInfo };
export type { EnvironmentInfo };
